<template>
  <el-dialog title="选择短剧" :visible.sync="innerVisible" class="dialog-table" width="800px"
    :before-close="closeDialogTable">
    <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
      <el-form-item label="短剧ID" prop="svId">
        <el-input v-model="formInline.svId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search"
          @clear="search" style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="短剧名" prop="svName">
        <el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable @keyup.enter.native="search"
          @clear="search" style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="tableTh">
      <el-table :data="tableData.result" ref="singleTable" border highlight-current-row
        @current-change="handleCurrentChangeTable" height="345" row-key="id" style="width: 100%"
        class="tableStyle table-radio">
        <el-table-column align="center" width="55" label>
          <template slot-scope="scope">
            <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected"
              :label="scope.row.id"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="封面" width="100">
          <template slot-scope="scope">
            <img class="cover-td" :src="scope.row.videolistVo.coverPath" height="50" />
          </template>
        </el-table-column>
        <el-table-column label="短剧名" width="200">
          <template slot-scope="scope">
            <p>短剧名：{{ scope.row.videolistVo.svName }}</p>
            <p>展示剧名：{{ scope.row.videolistVo.aliasName }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="albumId" label="剧目ID">
        </el-table-column>
        <el-table-column prop="statusOnline" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.rackStatus == 0" class="danger-text">未上线</span>
            <span v-if="scope.row.rackStatus == 1" class="succes-text">已上线</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="foot-table" style="text-align:center;">
        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
          :page-sizes="[5, 20, 50, 100, 200, 500]" :page-size="pageSize" background :current-page="currentPage"
          layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
        </el-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialogTable">取 消</el-button>
      <el-button type="primary" @click="tableSureBtn">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { listVideo } from "@/api/dysvzk/video/manage";
export default {
  name: 'VideoTableMedia',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    selectVideo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      innerVisible: this.visible,
      selected: [],
      formInline: {
        svId: '',
        svName: ''
      },
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: []
      },
      currentPage: 1,
      pageSize: 5,
      currentRow: '',
      appId: localStorage.getItem('appId'),
    }
  },
  watch: {
    visible(newValue) {
      this.innerVisible = newValue;
      console.log(this.selectVideo)
      // 弹框显示赋值默认值
      this.$nextTick(() => {
        this.$refs.singleTable.setCurrentRow(this.selectVideo)
      })
    },
    innerVisible(newValue) {
      this.$emit('update:visible', newValue);
    }
  },
  mounted() {
    this.getTableVideo()
  },
  methods: {
    search() {
      this.currentPage = 1
      this.getTableVideo()
    },
    resetQuery() {
      this.$refs['formInline'].resetFields()
      this.getTableVideo()
    },
    // 分页
    handleCurrentChange(value) {
      this.currentPage = value
      this.getTableVideo()
    },
    // pageSize切换
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableVideo()
    },
    // 单选
    handleCurrentChangeTable(val) {
      console.log('单选')
      this.$refs.singleTable.setCurrentRow(val);
      this.currentRow = val
      // this.selected = val.id
      console.log(val)
      this.selected = [val.id]
    },
    // 确定按钮
    tableSureBtn() {
      this.$emit('videoSure', this.currentRow);
      // this.$emit('cancelDialogVideo', false);
      // this.$refs.singleTable.setCurrentRow();
    },
    // 关闭弹框
    closeDialogTable() {
      console.log(22)
      this.$emit('cancelDialogVideo', false);
    },
    getTableVideo() {
      let json2 = {
        appId: this.appId,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      listVideo(paramJson).then(response => {
        if (response.data.head.flag === 0) {
          this.tableData = response.data.content
        } else {
          this.$message.error(response.data.head.desc)
        }
      });
    },
  }
}
</script>